<template>
  <nav id="Navbar">
    <ul class="nav navbar-nav">
      <li class="menu-item" @click="navbtn = 'centrale'">
        <router-link :class="[($route.path.replace('/','').indexOf('zaplecze/lista-centrala') > -1) ? 'activeNav' : '']" to="/zaplecze/lista-centrala">Centrale</router-link>
      </li>
      <li class="menu-item" @click="navbtn = 'moduly'">
        <router-link :class="[($route.path.replace('/','').indexOf('zaplecze/lista-moduly') > -1) ? 'activeNav' : '']" to="/zaplecze/lista-moduly">Moduły</router-link>
      </li>
      <li class="menu-item" @click="navbtn = 'centrala-obudowa'">
        <router-link :class="[($route.path.replace('/','').indexOf('zaplecze/centrala-obudowa') > -1) ? 'activeNav' : '']" to="/zaplecze/centrala-obudowa"
          >Obudowa - Centrala</router-link
        >
      </li>
      <li class="menu-item" @click="navbtn = 'modul-obudowa'">
        <router-link :class="[($route.path.replace('/','').indexOf('zaplecze/moduly-obudowa') > -1) ? 'activeNav' : '']"  to="/zaplecze/moduly-obudowa">Obudowa - Moduł</router-link>
      </li>
      <li class="menu-item" @click="navbtn = 'obudowy'">
        <router-link :class="[($route.path.replace('/','').indexOf('zaplecze/obudowy') > -1) ? 'activeNav' : '']"  to="/zaplecze/obudowy">Obudowy</router-link>
      </li>
      <li class="menu-item" @click="navbtn = 'producenci'">
        <router-link :class="[($route.path.replace('/','').indexOf('zaplecze/producenci') > -1) ? 'activeNav' : '']"  to="/zaplecze/producenci">Producenci</router-link>
      </li>
      <li class="menu-item" @click="navbtn = 'centrala'">
        <router-link to="/">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-arrow-90deg-up"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M4.854 1.146a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L4 2.707V12.5A2.5 2.5 0 0 0 6.5 15h8a.5.5 0 0 0 0-1h-8A1.5 1.5 0 0 1 5 12.5V2.707l3.146 3.147a.5.5 0 1 0 .708-.708l-4-4z"
            />
          </svg>
        </router-link>
      </li>
        <img src="../assets/logo.png" style="width: 158px;padding: 6px;position: absolute;right: 10px;" alt="">
      <!-- <Services title="Services" /> -->
    </ul>
    <ul id="Navbar-small">

    </ul>
  </nav>
</template>

<script>
// import Services from '../components/Services'
export default {
  name: "Navbar",
  data () {
    return {
      navbtn: 'centrale'
    }
  },
  components: {
    // Services
  },
};
</script>

<style scoped>
.navbar-nav {
  display: block;
}
#Navbar {
  background-color: #d0d0d0;
  width: 100%;
}
#Navbar ul {
  /* max-width: 525px; */
  /* margin: 0px auto; */
  list-style-type: none;
  padding: 0;
  overflow: hidden;
}

#Navbar ul li {
float: left;
height: 60px;
line-height: 30px;
background: #005097;
margin-right: 2px;
}

#Navbar ul li a {
  color: white;
  text-align: center;
  padding: 14px 16px;
  display: block;
  text-decoration: none;
}

#Navbar ul li a:hover {
  background-color: #0c6dd5;
}

#Navbar-small {
width: 100%;
height: 24px !important;
background: #b9b9b9;
}

.activeNav {
  background-color: #0c6dd5;
}
.active {
  background-color: #04aa6d;
}
</style>



// WEBPACK FOOTER //
// src/components/NavbarZaplecze.vue